var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 32.0837C25.5541 32.0837 32.0833 25.5545 32.0833 17.5003C32.0833 9.44617 25.5541 2.91699 17.5 2.91699C9.44584 2.91699 2.91666 9.44617 2.91666 17.5003C2.91666 25.5545 9.44584 32.0837 17.5 32.0837Z",
    fill: "#F6F9FF",
    stroke: "#B7D0FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.675 18.638C17.5729 18.6234 17.4417 18.6234 17.325 18.638C14.7583 18.5505 12.7167 16.4505 12.7167 13.8693C12.7167 11.2297 14.8458 9.08594 17.5 9.08594C20.1396 9.08594 22.2833 11.2297 22.2833 13.8693C22.2688 16.4505 20.2417 18.5505 17.675 18.638Z",
    fill: "#B7D0FF",
    stroke: "#B7D0FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3292 28.2619C24.7334 30.639 21.2917 32.0827 17.5001 32.0827C13.7084 32.0827 10.2667 30.639 7.6709 28.2619C7.81673 26.8911 8.69173 25.5494 10.2521 24.4994C14.248 21.8452 20.7813 21.8452 24.748 24.4994C26.3084 25.5494 27.1834 26.8911 27.3292 28.2619Z",
    fill: "#B7D0FF",
    stroke: "#B7D0FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCircle);
export default __webpack_public_path__ + "static/media/profile-circle.0b52e7459d13911ca578d5eaefdc0f7c.svg";
export { ForwardRef as ReactComponent };